import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';
import {
  ClinicSettingsItem,
  ClinicSettingsPage,
} from '../../models/Settings/ClinicSettings';

export interface ClinicSettingsState {
  items: ClinicSettingsItem[];
  totalItemsCount: number;
  status: Status;
}

export interface ClinicSettingsRequest {
  ClinicNameSearch: string;
  PageIndex: number;
  PageSize: number;
}

const initialState: ClinicSettingsState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getClinicSettings = createAsyncThunk(
  'clinicSettings/getClinicSettings',
  async (request: ClinicSettingsRequest, { rejectWithValue }) => {
    try {
      const params: Record<string, unknown> = {
        PageIndex: request.PageIndex,
        PageSize: request.PageSize,
      };
      if (request.ClinicNameSearch) {
        params['Filter.ClinicNameSearch'] = request.ClinicNameSearch;
      }
      const response = await apiClientWithApi.get<ClinicSettingsPage>(
        'settings/clinic',
        { params },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue('Не удалось получить список клиник!');
    }
  },
);

export const clinicSettingsSlice = createSlice({
  name: 'clinicSettings',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClinicSettings.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
      })
      .addCase(getClinicSettings.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
      })
      .addCase(getClinicSettings.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список клиник';
      });
  },
});

export default clinicSettingsSlice.reducer;

export const selectClinicSettings = (state: RootState) =>
  state.clinicSettings.items;
export const selectClinicSettingsTotalCount = (state: RootState) =>
  state.clinicSettings.totalItemsCount;
export const clinicSettingsStatus = (state: RootState) =>
  state.clinicSettings.status;
